
export const NODE_ENV = 'production';
export const VERSION = '4.42.10';
export const BUILD_VERSION = 'latest-test';
export const BASE_SERVICE_URL = 'https://explorium.bilberry.app';
export const BASE_MEMBERSHIP_API_URL = 'https://membership-api-dev.bilberry.no';
export const DIBS_CHECKOUT_SRC = 'https://test.checkout.dibspayment.eu/v1/checkout.js?v=1';
export const USE_SERVICE_PROXY = false;
export const SERVICE_PROXY_URL = 'http://localhost:8080';
